import { create } from "zustand"
import { Ticket } from "../types/entities/ticket"

const SEEN_KEY = "ck-unpaid-ticket-seen"

export type UnpaidNoticeView = "closed" | "open" | "minimized"

function readSeenId(): string | null {
    try {
        return sessionStorage.getItem(SEEN_KEY)
    } catch {
        return null
    }
}

function writeSeenId(id: string) {
    try {
        sessionStorage.setItem(SEEN_KEY, id)
    } catch {
        /* ignore */
    }
}

type UnpaidOrderState = {
    unpaidTicket: Ticket | null
    loading: boolean
    seenOrderId: string | null
    noticeView: UnpaidNoticeView
    setUnpaidTicket: (ticket: Ticket | null) => void
    setLoading: (loading: boolean) => void
    markSeen: (orderId: string) => void
    hasUnreadUnpaid: () => boolean
    openNotice: () => void
    minimizeNotice: () => void
    closeNotice: () => void
}

export const unpaidOrderStore = create<UnpaidOrderState>((set, get) => ({
    unpaidTicket: null,
    loading: false,
    seenOrderId: readSeenId(),
    noticeView: "closed",

    setUnpaidTicket: ticket => {
        if (!ticket) {
            set({ unpaidTicket: null, noticeView: "closed" })
            return
        }
        set({ unpaidTicket: ticket })
    },

    setLoading: loading => set({ loading }),

    markSeen: orderId => {
        writeSeenId(orderId)
        set({ seenOrderId: orderId })
    },

    hasUnreadUnpaid: () => {
        const { unpaidTicket, seenOrderId } = get()
        return !!unpaidTicket && unpaidTicket.id !== seenOrderId
    },

    openNotice: () => set({ noticeView: "open" }),

    minimizeNotice: () => set({ noticeView: "minimized" }),

    closeNotice: () => set({ noticeView: "closed" }),
}))
